module.exports = __webpack_public_path__ + "static/media/hero-theeth.54c2c4e9.png";